<template>
    <base-component ref="root" :taxpayerInfo="currentTaxpayer">
        <template slot="form">
            <report-search-form :fetch="fetchData" :kkms="kkms" :dealerIin="currentTaxpayer != null ? currentTaxpayer.iin : null" :pageSize="pageSize" :offset="offset" :setOffset="setOffset"/>
        </template>
        <template slot="createButton">
            <b-button v-if="!showCreateReport" @click="toggleCreateReport" variant="primary">
                <plus-icon title="" />&nbsp;{{ $t('general.create') }}
            </b-button>
        </template>
        <template slot="createForm">
            <report-create-form v-if="showCreateReport" :kkms="kkms" :close-form="toggleCreateReport" />
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card no-body class="flex-fill flex-shrink-0">
                <b-tabs card>
                    <b-tab :title="$t('menu.kkms')" @click="openKkms"></b-tab>
                    <b-tab v-if="!isInspector" :title="$t('menu.blockedKkms')" @click="openBlockedKkms"></b-tab>
                    <b-tab :title="$t('menu.reports')" active>
                        <pagination :pageSize="this.pageSize" :offset="offset" :listLength="reportList.length" :setOffset="setOffset" />
                        <report-list-view :items="reportList" :get-reports="fetchData" />
                    </b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tickets')" @click="openTickets"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.moneyPlacements')" @click="openMoneyPlacements"/>
                    <b-tab v-if="!isOperator" :title="$t('menu.tasks')" @click="openTasks"/>
                </b-tabs>
            </b-card>
        </template>

    </base-component>  
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata';
import { normalizeReports, normalizeArrayOfCcm } from '@/utils/utils';

const ReportSearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/report/ReportSearchForm.vue')
const ReportListView = () => import(/* webpackChunkName: "chunk-views" */ '@/components/report/ReportListView.vue')
const ReportCreateForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/report/ReportCreateForm.vue')
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue')

export default {
    name: 'Reports',
    mixins: [ AppData ],
    components: {
        ReportSearchForm,
        ReportListView,
        ReportCreateForm,
        Pagination
    },
    mounted() {
        this.getCurrentTaxpayer();       
        if (Object.keys(this.$route.params).length || this.currentTaxpayer) {
            this.getKkms(this.$route.params.id || this.$route.params.dealerId || this.currentTaxpayer.id);  
        } else if (this.isTaxpayer) {
            //This is workaround for Bug 223  
            const unsubscribe = this.$store.subscribe( async (mutation, state) => {
                if (mutation.type === 'setTaxpayer') { 
                    if (state.taxpayer != null)
                        this.getKkms(state.taxpayer.id);
                    
                    unsubscribe();
                }
            });
        }
    },
    data() {
        return {
            showAlert: false,
            alert: '',
            showCreateReport: false,
            reportList: [],
            kkms: [],
            pageSize: 20,
            offset: 0
        }
    },
    computed: {
        kkmOptions() {
            return normalizeArrayOfCcm(this.kkms);
        }
    },
    methods: {
        fetchData(formData) {
            this.hideAlert()
            if (this.offset === 0) {
                formData.createDateEnd = formData.createDateEndForm
            }

            const onSuccess = response => {
                this.reportList = normalizeReports(response);

                if (this.offset === 0 && this.reportList[0] != null){
                    formData.createDateEnd = this.reportList[0].creationDate;
                    formData.createDateEnd.setMilliseconds(formData.createDateEnd.getMilliseconds() + 1);
                }
            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.report.getAll,
                formData,
                onSuccess,
                this.displayAlert);
        },
        setOffset(newValue) {
            this.offset = newValue
        },
        toggleCreateReport() {
            this.hideAlert()
            this.showCreateReport = !this.showCreateReport
        },
        openKkms() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkms' })
            } else {
                this.$router.push({ name: 'childKkm' })
            }
        },
        openTickets() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tickets' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTickets' })
            }
        },
        openMoneyPlacements() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'moneyPlacements' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childMoneyPlacements' })
            }
        },
        openBlockedKkms() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkmsBlocked' })
            } else if (this.isOperator) {
                this.$router.push({ name: 'blockedKkms' })
            }
        },
        openTasks() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tasks' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTasks' })
            }
        },
        async getKkms(dealerId) {
            try {
                this.kkms = await this.$request.sendRequestAsync(
                    this,
                    this.$appConfig.apiUrls.kkm.getAll,
                    { dealerId: dealerId }
                );
            }
            catch(errorCode) {
                this.displayAlert(errorCode);
            }
        }
    }
}
</script>
